import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Phone, MessageCircle, Check, ArrowRight } from "lucide-react";
import { api } from "@/lib/api";
import { useSEO, useSettings } from "@/lib/hooks";
import RequestForm from "@/components/sections/RequestForm";
import FAQSection from "@/components/sections/FAQSection";

export default function ServiceDetailPage() {
  const { slug } = useParams();
  const s = useSettings();
  const [svc, setSvc] = useState(null);
  useEffect(() => {
    api.get(`/services/${slug}`).then((r) => setSvc(r.data)).catch(() => setSvc(false));
  }, [slug]);

  useSEO({
    title: svc ? svc.meta_title : "Service — Depann7",
    description: svc ? svc.meta_description : undefined,
  });

  if (svc === false) return <div className="text-center py-32 text-txt-500">Service introuvable.</div>;
  if (!svc) return <div className="text-center py-32 text-txt-500">Chargement...</div>;

  return (
    <div className="bg-white">
      <div className="relative h-[40vh] min-h-[280px] bg-cover bg-center" style={{
        backgroundImage: `linear-gradient(180deg, rgba(27,27,29,0.5) 0%, rgba(27,27,29,0.95) 100%), url(${svc.image_url})`,
      }}>
        <div className="max-w-6xl mx-auto h-full px-4 lg:px-6 flex items-end pb-8">
          <div>
            <div className="text-brand-300 text-xs uppercase tracking-widest font-bold">Service</div>
            <h1 className="text-3xl lg:text-5xl font-extrabold text-white mt-2">{svc.title}</h1>
          </div>
        </div>
      </div>

      <div className="max-w-6xl mx-auto px-4 lg:px-6 py-12 grid lg:grid-cols-3 gap-10">
        <div className="lg:col-span-2 space-y-6">
          <p className="text-txt-700 text-lg leading-relaxed">{svc.long_description}</p>
          <div className="bg-surface-50 border border-surface-200 rounded-2xl p-6">
            <h3 className="text-lg font-extrabold text-txt-900">Avantages</h3>
            <ul className="mt-4 grid sm:grid-cols-2 gap-3">
              {[
                "Intervention rapide 24h/24",
                "Tarif annoncé avant départ",
                "Matériel professionnel adapté",
                "Couverture toute Île-de-France",
                "Paiement CB / espèces / virement",
                "Support WhatsApp réactif",
              ].map((a) => (
                <li key={a} className="flex items-start gap-2 text-txt-700 text-sm">
                  <div className="w-5 h-5 rounded-full bg-green-50 flex items-center justify-center shrink-0 mt-0.5"><Check className="text-green-600" size={12} /></div>
                  <span>{a}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className="bg-brand-50 border border-brand-200 rounded-2xl p-6">
            <div className="text-sm font-semibold text-brand-700">Tarif indicatif</div>
            <div className="text-brand text-3xl font-extrabold mt-1">{svc.tarif_indicatif}</div>
            <p className="text-txt-500 text-sm mt-2">Le tarif final dépend de la distance, de l'accessibilité et de l'état du véhicule.</p>
          </div>
          <div className="flex flex-col sm:flex-row gap-3">
            <a href={`tel:${s?.company_phone_raw || ""}`} className="flex-1 bg-brand hover:bg-brand-600 text-white font-bold rounded-xl py-4 inline-flex items-center justify-center gap-2 transition-colors"><Phone size={18} /> Appeler</a>
            <a href={`https://wa.me/${s?.company_whatsapp || ""}`} target="_blank" rel="noreferrer" className="flex-1 bg-whats hover:bg-whats-hover text-white font-bold rounded-xl py-4 inline-flex items-center justify-center gap-2 transition-colors"><MessageCircle size={18} /> WhatsApp</a>
            <Link to="/demande" className="flex-1 border-2 border-brand text-brand hover:bg-brand-50 font-bold rounded-xl py-4 inline-flex items-center justify-center gap-2 transition-colors">Devis <ArrowRight size={18} /></Link>
          </div>
        </div>
        <div className="bg-white border border-surface-200 rounded-2xl shadow-card overflow-hidden"><RequestForm compact /></div>
      </div>

      <FAQSection />
    </div>
  );
}
